export const PCC_STATUS = {
  1: 'Cerrado',
  2: 'Cancelado',
  3: 'Abierto',
  4: 'Esperando respuesta cliente', // If changes here, update MyPCC.js item.status === 4
};

export const statusOptions = Object.entries(PCC_STATUS).map(([value, label]) => ({
  value: Number(value),
  label,
}));